import { ArchiveSyncIcon } from './ArchiveSyncIcon';

/**
 * author: Colton Wiscombe
 * id BCB51994-105E-404E-96D2-1242AEB13CDB
 * name archive-sync
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/archive-sync.svg
 * tags
 */
export const BoxSyncIcon = ArchiveSyncIcon;
export default BoxSyncIcon